import * as React from 'react';
import DatePicker from "react-multi-date-picker"
import { Button, Divider, FormControl, FormHelperText, Grid, Input, InputAdornment, Typography } from '@mui/material';
import "react-multi-date-picker/styles/colors/green.css"
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import useSubmitLock from '../../../../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;


export default function IncrementoSalario(props) {
    const { lote } = props
    const { periodo } = props
    const { idempleado } = props
    const { notificacion } = props
    const { idconcepto } = props
    const { obtenerdatolote } = props
    const { empleadodepta } = props
    const { datotodoempleado } = props
    const { submitting, runWithSubmitLock } = useSubmitLock()

    const [datearray, setDatearray] = React.useState('')
    const [dates, setDates] = React.useState('')
    const [salarioahora, setSalarioAhora] = React.useState()

    const fechainicio = periodo.fechainicio + 1
    const fechafin = periodo.fechafin + 1

    const weekDays = ["Dom", "Lun", "Mar", "Mier", "Jue", "Vier", "Sab"]
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]

    const IncrementoSal = (e) => {
        e.preventDefault()
        runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        const salarioactual2 = parseFloat(datotodoempleado.sdi);
        const salarioahora2 = parseFloat(salarioahora)
        const resul = {
            variant: 'warning',
            msg: 'Debe seleccionar por lo menos una fecha'
        }
        const resul2 = {
            variant: 'warning',
            msg: 'EL SALARIO NO DEBE SER IGUAL O MENOR AL ACTUAL'
        }

        if (datearray === '' || idempleado === '') {
            notificacion(resul)

        } else {

            if (salarioactual2 >= salarioahora2) {
                notificacion(resul2)
            } else {

                var myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${token}`);
                myHeaders.append("Content-Type", "application/json");

                var raw = JSON.stringify({
                    "idlote": lote,
                    "iddepartamento": empleadodepta,
                    "idempleado": idempleado,
                    "codigoempleado": datotodoempleado.codigoempleado,
                    "nombrelargo": datotodoempleado.nombrelargo,
                    "idperiodo": periodo.idperiodo,
                    "fechaAplicacion": datearray,
                    "tipoMovimiento": `${idconcepto}`,
                    "actualSalario": salarioactual2,
                    "nuevoSalario": salarioahora2
                });

                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: raw,
                    redirect: 'follow'
                };

                try {

                    const response = await fetch(`${REACT_APP_API_URL}/pdim/movimiento`, requestOptions)
                    const resultado = await response.json();

                    return (notificacion(resultado), obtenerdatolote(lote), setDatearray(''), setDates(), setSalarioAhora(''))
                } catch (error) {
                    console.log('Algo salio mal', error);

                }
            }
        }
        })
    }

    const handchange = (date) => {
        setDates(date);
        const fechastring = date.toString();
        setDatearray(fechastring);
    };

    return (
        <div>
            <br />
            <br />
            <form onSubmit={IncrementoSal}>
                <DatePicker
                    weekDays={weekDays}
                    months={months}
                    mainPosition="top"
                    fixMainPosition={true}
                    calendarPosition={`top-center`}

                    style={{
                        backgroundColor: "aliceblue",
                        height: "35px",
                        borderRadius: "3px",
                        fontSize: "16px",
                        padding: "3px 10px"
                    }}
                    disableYearPicker
                    className="green"
                    value={dates}
                    minDate={fechainicio}
                    maxDate={fechafin}
                    onChange={handchange}
                    format="YYYY-MM-DD"
                    sort
                    plugins={[
                        <DatePanel />
                    ]}
                />
                <FormHelperText id="outlined-weight-helper-text">Fecha de aplicacion</FormHelperText>
                <br />
                <Grid container spacing={2}>
                    <Grid item sm={3}>
                        <FormControl variant="standard" sx={{ m: 2, width: '100%' }}>
                            <Typography>$ {datotodoempleado.sdi}</Typography>
                            <Divider />
                            <FormHelperText id="standard-weight-helper-text"> Actual SDI</FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item sm={6}>
                        <FormControl variant="standard" sx={{ m: 1 }}>
                            <Input
                                required
                                onChange={e => setSalarioAhora(e.target.value)}
                                type='number'
                                step="0.01"
                                value={salarioahora}
                                placeholder="0"
                                id="standard-adornment-weight"
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                aria-describedby="standard-weight-helper-text"
                                inputProps={{
                                    'aria-label': 'weight',
                                    'step': "0.01"
                                }}
                            />
                            <FormHelperText id="standard-weight-helper-text">Nuevo SDI</FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>




                <br />
                <Button variant='contained' type='submit' disabled={submitting}>Agregar</Button>
            </form>
        </div>
    );
}




